import styles from './ProjectListTableHeader.module.css';

export const ProjectListTableHeader = () => (
    <div className={styles.row}>
        <div className={styles.title}>Name</div>
        <div className={styles.date}>Creation Date</div>
        <div className={styles.dateTarget}>Target Date</div>
        <div className={styles.address}>Address</div>
        <div className={styles.actions}>Actions</div>
    </div>
);
